/**
 * MAIN HEADER VIEW TEMPLATE
 *
 * @version 0.1
 */

import React from 'react';

import MainMenu from './templates/Header.mainMenu.jsx';
import reduxStore from './../../reduxStore';



export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = reduxStore.getState();
        if (this.props.disableMenu) {
            this.state.user.isLoggedIn = false;
        }
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState());
            }
        );
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    render() {
        return (
                <MainMenu user={this.state.user}
                          menuStateClass={this.state.header.menuStateClass}
                          subMenuMessage={this.state.header.subMenuMessage}
                          values={this.state.header.values}
                          helpUrl={this.state.user.helpUrlRoot + this.state.header.helpUrl}
                          language={this.state.user.preferences.language} 
                />
        );
    }

}


// WEBPACK FOOTER //
// ./src/scripts/reusable/Header/Header.index.jsx